<template>
  <div id="leco-app" class="leco-page-wrapper">
    <LecoHeader />
    <router-view></router-view>
    <LecoFooter />
  </div>
</template>

<script>
import LecoHeader from "@/components/LECO_Header";
import LecoFooter from "@/components/LECO_Footer";

export default {
  name: "App",
  components: {
    LecoHeader,
    LecoFooter
  }
};
</script>

<style>
:root {
  --leco-link-color: #e02d00 !important;
  --under600-font-size: 14px;
}

body {
  font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic, 游ゴシック体,
    sans-serif !important;
}

.leco-page-wrapper {
  width: 1240px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.leco-content {
  display: flex;
  flex-direction: column;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.7s;
}

.v-enter,
.v-leave-to {
  opacity: 0;
}

.page-title {
  padding: 0.5em;
  /*文字周りの余白*/
  margin-bottom: 0.5em;
  /* 下部の余白 */
  color: #494949;
  /*文字色*/
  background: #fffaf4;
  /*背景色*/
  border-left: solid 5px #ffaf58;
  /*左線（実線 太さ 色）*/
  font-weight: 600;
  /* 高さ */
  height: 40px;

  /* 左右揃えのためのスタイル */
  display: flex;
  /* 基本は左寄せ */
  justify-content: flex-start;
  /* 水平方向の中央揃え */
  align-items: center;
}

@media screen and (max-width: 1240px) {
  .leco-page-wrapper {
    width: 100%;
  }
}

@media screen and (max-width: 600px) {
  body {
    font-size: var(--under600-font-size) !important;
  }
  .page-title {
    height: auto;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
  }
}

/* 凡例エリア全体のスタイル */
.hanrei-area {
  color: #343a40;
  font-size: 75%;
}

/* 画面の凡例表記のラベルスタイル */
.hanrei-label {
  background: #6c757d;
  border-radius: 24px;
  padding: 0px 15px;
  color: white;
  margin-right: 6px;
}
</style>
